export default __webpack_public_path__ + "static/media/bike.ffc6988b.mp4";